import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { getInitials } from '../utils/stringUtils';
import { getGradientClass } from '../utils/avatarColorUtil';

export function useUserAvatar(name: MaybeRefOrGetter<string>) {
  const initials = computed(() => getInitials(toValue(name)));
  const colorClass = computed(() => getGradientClass(initials.value));
  return { initials, colorClass };
}
